import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RolesComponent } from './components/roles/roles.component';
import { EnergyComponent } from './components/energy/energy.component';
import { InflabComponent } from './components/inflab/inflab.component';
import { WeightComponent } from './components/weight/weight.component';
import { GitlabVersionComponent } from './components/gitlab-version/gitlab-version.component';
import {AudioRecordingComponent} from './components/audio-recording/audio-recording.component';
import {PassComponent} from './components/pass/pass.component';
import {CodeReviewComponent} from './components/code-review/code-review.component';
import {ArchbuildComponent} from './components/archbuild/archbuild.component';
import {RelayComponent} from './components/relay/relay.component';
import {ElkExceptionComponent} from './components/elk-exception/elk-exception.component';
import {PoiGitComponent} from './components/poi-git/poi-git.component';
import {PoiDeployedVersionComponent} from './components/poi-deployed-version/poi-deployed-version.component';
import {SseTestComponent} from './components/sse-test/sse-test.component';
import {PoiDbComponent} from './poi-db/poi-db.component';
import {PoiAppStatusComponent} from './components/poi-app-status/poi-app-status.component';
import {ChromeKrakenComponent} from './components/chrome-kraken/chrome-kraken.component';
import {MozPlacesComponent} from './components/moz-places/moz-places.component';
import {PoiOrgComponent} from './components/poi-org/poi-org.component';
import {MapComponent} from './map/map.component';
import {MapConfigComponent} from './map/map-config/map-config.component';
import {OutdoorMapComponent} from './outdoor-map/outdoor-map.component';
import {ArchiveComponent} from './components/archive/archive.component';
import {StracliCmdComponent} from './components/stracli-cmd/stracli-cmd.component';
import {FileScanComponent} from './components/file-scan/file-scan.component';
import {QwenComponent} from './components/qwen/qwen.component';
import {AiComponent} from './components/ai/ai.component';
import {MailComponent} from './components/mail/mail.component';
import {ScreenshotStreamComponent} from './components/screenshot-stream/screenshot-stream.component';
import {InsoDockerComponent} from './components/inso-docker/inso-docker.component';

const routes: Routes = [
  {
    path: 'energy',
    component: EnergyComponent
  },
  {
    path: 'weight',
    component: WeightComponent
  },
  {
    path: 'inflab',
    component: InflabComponent
  },
  {
    path: 'gitlab',
    component: GitlabVersionComponent
  },
  {
    path: 'arec',
    component: AudioRecordingComponent
  },
  {
    path: 'pass',
    component: PassComponent
  },
  {
    path: 'codeReview',
    component: CodeReviewComponent,
  },
  {
    path: 'archbuild',
    component: ArchbuildComponent,
  },
  {
    path: 'relay',
    component: RelayComponent,
  },
  {
    path: 'elkException',
    component: ElkExceptionComponent,
  },
  {
    path: 'git',
    component: PoiGitComponent,
  },
  {
    path: 'poiDeployedVersion',
    component: PoiDeployedVersionComponent,
  },
  {
    path: 'sse',
    component: SseTestComponent,
  },
  {
    path: 'pdb',
    component: PoiDbComponent,
  },
  {
    path: 'pas',
    component: PoiAppStatusComponent,
  },
  {
    path: 'ck',
    component: ChromeKrakenComponent,
  },
  {
    path: 'mozillaPlaces',
    component: MozPlacesComponent,
  },
  {
    path: 'poiOrg',
    component: PoiOrgComponent,
  },
  {
    path: 'map',
    component: MapComponent,
  },
  {
    path: 'mapConfig',
    component: MapConfigComponent,
  },
  {
    path: 'outdoor-map',
    component: OutdoorMapComponent,
  },
  {
    path: 'archive',
    component: ArchiveComponent,
  },
  {
    path: 'stracliCmd',
    component: StracliCmdComponent,
  },
  {
    path: 'file-scan',
    component: FileScanComponent,
  },
  {
    path: 'qwen',
    component: QwenComponent,
  },
  {
    path: 'ai',
    component: AiComponent,
  },
  {
    path: 'mail',
    component: MailComponent,
  },
  {
    path: 'screenshotStream',
    component: ScreenshotStreamComponent,
  },
  {
    path: 'insoDocker',
    component: InsoDockerComponent,
  },
  {
    path: '**',
    component: RolesComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
